'use strict';

/** @type {import('./type')} */
module.exports = TypeError;



//////////////////
// WEBPACK FOOTER
// ../~/es-errors/type.js
// module id = 233
// module chunks = 1